"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewTypes = exports.operandLetters = exports.operandLetterIndexes = exports.inputGroupFieldTypes = exports["default"] = void 0;
var operandLetterIndexes = exports.operandLetterIndexes = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
  I: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
  N: 13,
  O: 14,
  P: 15,
  Q: 16,
  R: 17,
  S: 18,
  T: 19,
  U: 20,
  V: 21,
  W: 22,
  X: 23,
  Y: 24,
  Z: 25,
  AA: 26,
  AB: 27,
  AC: 28,
  AD: 29,
  AE: 30,
  AF: 31,
  AG: 32,
  AH: 33,
  AI: 34,
  AJ: 35,
  AK: 36,
  AL: 37,
  AM: 38,
  AN: 39,
  AO: 40,
  AP: 41,
  AQ: 42,
  AR: 43,
  AS: 44,
  AT: 45,
  AU: 46,
  AV: 47,
  AW: 48,
  AX: 49,
  AY: 50,
  AZ: 51
};
var operandLetters = exports.operandLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ'];
var viewTypes = exports.viewTypes = {
  list: 'list',
  table: 'table'
};
var inputGroupFieldTypes = exports.inputGroupFieldTypes = {
  inputGroupRowHeader: 'inputGroupRowHeader',
  inputGroupDropdownCell: 'inputGroupDropdownCell',
  inputGroupTextCell: 'inputGroupTextCell',
  inputGroupFooter: 'inputGroupFooter'
};
var _default = exports["default"] = {
  operandLetters: operandLetters,
  viewTypes: viewTypes,
  inputGroupFieldTypes: inputGroupFieldTypes
};